

export const to_imgToSmall = (imgUrl) => imgUrl.replace(/\/tpl\/[^/]+\//, "/tpl/small/");

